enum MortgageTypeEnum {
    FirstMortgage = 'FIRST_MORTGAGE',
    SecondMortgage = 'SECOND_MORTGAGE',
}

export default MortgageTypeEnum;
